// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import ShowImg from '../components/ShowImg';

// img
import singleDownloadImg from '../img/download_img.png';
import figureImgS8 from '../img/Figure_S8.png';
import figureImgS9 from '../img/Figure_S9.png';
import figureImgS10 from '../img/Figure_S10.png';

function Gaap11(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title">Genome annotation</h2>
            <h2 className="content_title2">Functional annotation</h2>
            <h2 className="contnet_description">(2) GO term mapping</h2>
            <div className="content_text">
                Mapping is the process of retrieving GO terms 
                associated with Hits (mapped sequences) obtained 
                via Blast search. GO database is a relational database 
                to store and manage annotations describing information 
                such as gene ontology, gene products, as well as functions 
                and activity sites of gene products. GO database can be 
                downloaded from AmiGO.
            </div>
            <div className="content_command_title">AmiGO</div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="http://amigo.geneontology.org/amigo" /><br/>
                </div>
            </div><br/>
            <li className="content_description">AmiGO Command</li>
            <div className="content_text">
                In GAAP, we retrieve the GO terms by running 
                the Mapping and Analyzing tools provided in Blast2GO.
            </div><br/>
            <li className="content_description">Result of Mapping</li>
            <div className="content_text">
                In the result of mapping, it is possible to obtain 
                detailed information about a GO term via linkage to the AmiGO site&nbsp;
                <ShowImg name="(Supplementary Figure S8)"
                        src= {figureImgS8}
                />.
                Also, based on frequency distribution of mapped GO terms, 
                we analyze the enrichment of GO categories&nbsp;
                <ShowImg name="(Supplementary Figure S9)"
                        src= {figureImgS9}
                />.
            </div><br/>
            <li className="content_description">Result of Analyzing</li>
            <div className="content_text">
                It can be used to analyze enzyme codes involved in 
                KEGG (Kyoto Encyclopedia of Genes and Genomes) 
                pathways and predict interactions between gene products&nbsp;
                <ShowImg name="(Supplementary Figure S10)"
                        src= {figureImgS10}
                />.
            </div><br/>
            <div className="content_buttons_div">
                <Link to="/Gaap10"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/"><button className="content_button">Home</button></Link>
            </div>
        </div>
    );
}

export default Gaap11;